import { t } from 'bv-i18n';
import { v as bvVar } from 'bv';
import { accountId } from 'bv-helpers/session';
import { DAY_IN_MILLIS } from 'bv-helpers/datetime';

export const launchPushNotifications = () => {
  if (window.UA) {
    window.UA.then((sdk) => {
      sdk.getChannel().then((channel) => {
        channel.namedUser.attributes.set({ ua_named_user_id: accountId() });
        channel.namedUser.set(accountId());
      });
      sdk.plugins.load('html-prompt', window.JSBundles.airShip.prompt, {
        askAgainDelay: (7 * DAY_IN_MILLIS) / 1000,
        stylesheet: window.CSSBundles.airship,
        i18n: {
          en: {
            title: t('push_notifications.airship_prompt.title'),
            message: t('push_notifications.airship_prompt.message'),
            accept: t('push_notifications.airship_prompt.accept'),
            deny: t('push_notifications.airship_prompt.deny'),
          },
        },
        logo: bvVar('urbanAirshipConfig').defaultIcon,
      })
        .then((plugin) => plugin.prompt());
    });
  }
};
